export enum AtiraLinkPlanLinksCount {
  PLAN_0 = '1',
  PLAN_1 = '1',
  PLAN_2 = '2',
}
